<template>
  <div class="md-layout">
    <simple-wizard class="md-layout-item">
      <template slot="header">
        <h3 class="title">Crea tu cuenta</h3>
        <h5 class="category">
          Esta información servirá para que inicies sesión y saber quién eres.
        </h5>
      </template>
      <wizard-tab :before-change="() => validateStep('step1')">
        <template slot="label"> Información Básica </template>
        <first-step ref="step1" @on-validated="onStepValidated1"></first-step>
      </wizard-tab>

      <wizard-tab :before-change="() => validateStep('step2')">
        <template slot="label"> Identificación </template>
        <second-step ref="step2" @on-validated="onStepValidated2"></second-step>
      </wizard-tab>

      <wizard-tab :before-change="() => validateStep('step3')">
        <template slot="label">
          Credenciales y Contacto
        </template>
        <third-step
          :messageLoading="messageLoading"
          :valueLoading="valueLoading"
          ref="step3"
          @on-validated="wizardComplete"
        ></third-step>
      </wizard-tab>
    </simple-wizard>
  </div>
</template>
<script>
import FirstStep from "./AccountRegistrationWizard/FirstStep.vue";
import SecondStep from "./AccountRegistrationWizard/SecondStep.vue";
import ThirdStep from "./AccountRegistrationWizard/ThirdStep.vue";
import Swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "@/components";
import gql from "graphql-tag";
import axios from "axios";
import store from "../../store";
import Constants from "../../constants";
import { onLogin } from "../../vue-apollo.js";

export default {
  data() {
    return {
      wizardModel: {},
      capCityDocExp: null,
      capDomainDocType: null,
      capDomainSex: null,
      capDomainCellPType: null,
      imageF: null,
      imageB: null,
      imageFace: null,
      valueLoading: 0,
      messageLoading: "Cargando",
      modalAdress: true,
      pSecurityQuestions: null,
      securityAnswers: null,
      counter: 0
    };
  },
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    SimpleWizard,
    WizardTab
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated1(validated, model, sex) {
      this.capDomainSex = sex;
      this.wizardModel = { ...this.wizardModel, ...model };
      this.modalAdress = true;
    },
    onStepValidated2(
      validated,
      model,
      imageFormF,
      imageFormB,
      capCityDocExp,
      capDomainDocType
    ) {
      this.imageF = imageFormF;
      this.imageB = imageFormB;
      this.capCityDocExp = capCityDocExp;
      this.capDomainDocType = capDomainDocType;
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    beforeClose(event) {
      var x = 0;
      var intervalID = setInterval(function() {
        if (this.isLoading) {
          event.cancel();
        } else window.clearInterval(intervalID);
        if (++x === 3) {
          window.clearInterval(intervalID);
        }
      }, 100);
    },
    wizardComplete(
      validated,
      model,
      input,
      capDomainCellPType,
      pSecurityQuestions,
      securityAnswers
    ) {
      this.wizardModel = { ...this.wizardModel, ...model };
      this.capDomainCellPType = capDomainCellPType;
      this.pSecurityQuestions = pSecurityQuestions;
      this.securityAnswers = securityAnswers;
      this.imageFace = input;
      this.messageLoading = "Creando cuenta.";
      this.valueLoading = 10;

      this.$apollo
        .mutate({
          mutation: gql`
            mutation createAccount(
              $account: pAccount!
              $capCityDocExp: Int!
              $capDomainDocType: Int!
              $capDomainSex: Int!
              $capDomainCellPType: Int!
            ) {
              createAccount(
                account: $account
                capCityDocExp: $capCityDocExp
                capDomainDocType: $capDomainDocType
                capDomainSex: $capDomainSex
                capDomainCellPType: $capDomainCellPType
              ) {
                userId
                firstName
                secondName
                lastName
                secondLastName
                email
                token
                userType
                documentValue
                hasProfile
              }
            }
          `,
          variables: {
            account: this.wizardModel,
            capCityDocExp: this.capCityDocExp,
            capDomainDocType: this.capDomainDocType,
            capDomainSex: this.capDomainSex,
            capDomainCellPType: this.capDomainCellPType
          },
          update: (cache, mutationResult) => {
            var result = mutationResult.data.createAccount;
            onLogin(this.$apollo.provider.defaultClient, result.token, result);
            let accountId = mutationResult.data.createAccount.userId;
            if (sessionStorage.getItem(Constants.CREDIT_DAYS) == null) {
              this.sendPhotosForRekognition(
                accountId,
                this.wizardModel.documentValue
              );
            } else {
              this.messageLoading = "Preparando primer crédito.";
              this.valueLoading = 25;
              this.$apollo
                .mutate({
                  mutation: gql`
                    mutation createCredit(
                      $credit: pCredit!
                      $capAccount: String!
                    ) {
                      createCredit(credit: $credit, capAccount: $capAccount) {
                        creditId
                        dayLimit
                      }
                    }
                  `,
                  variables: {
                    credit: {
                      dayLimit: sessionStorage.getItem(Constants.CREDIT_DAYS),
                      moneyBase: sessionStorage.getItem(Constants.CREDIT_VALUE)
                    },
                    capAccount: this.wizardModel.documentValue
                  },
                  update: (cache, mutationResult) => {
                    this.sendPhotosForRekognition(
                      accountId,
                      this.wizardModel.documentValue
                    );
                  }
                })
                .catch(error => {
                  this.valueLoading = 0;
                  Constants.catchError(
                    error,
                    this.$apollo.provider.defaultClient,
                    this,
                    true
                  );
                });
            }
          }
        })
        .catch(error => {
          this.valueLoading = 0;
          Constants.catchError(
            error,
            this.$apollo.provider.defaultClient,
            this,
            true
          );
        });
    },
    sendPhotosForRekognition(accountId, documentValue) {
      this.imageF.set("documentValue", documentValue);
      this.imageB.set("documentValue", documentValue);

      this.imageF.set("reason", Constants.KEY_NAME_REASON_DOCUMENT_PICTURE);
      this.imageB.set(
        "reason",
        Constants.KEY_NAME_REASON_DOCUMENT_PICTURE_BACK
      );

      this.messageLoading = "Subiendo imagen cédula frontal.";
      this.valueLoading = 35;

      axios({
        url: store.state.backend + "/uploadUserFiles",
        method: "POST",
        data: this.imageF,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data"
        }
      })
        .then(response => {
          this.messageLoading = "Subiendo imagen cédula trasera.";
          this.valueLoading = 60;
          axios({
            url: store.state.backend + "/uploadUserFiles",
            method: "POST",
            data: this.imageB,
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data"
            }
          }).then(response => {
            this.messageLoading = "Subiendo foto en tiempo real.";
            this.valueLoading = 75;
            let vm = this;
            this.imageFace.toBlob(function(blob) {
              const formData = new FormData();
              formData.set("files", blob, "fotoChequeoFrontal.png");
              formData.set("documentValue", documentValue);
              formData.set(
                "reason",
                Constants.KEY_NAME_REASON_RECOGNITION_PICTURE
              );
              axios({
                url: store.state.backend + "/uploadUserFiles",
                method: "POST",
                data: formData,
                headers: {
                  Accept: "application/json",
                  "Content-Type": "multipart/form-data"
                }
              })
                .then(response => {
                  vm.counter = vm.counter + 1;
                  vm.messageLoading = "Identificando rostros.";
                  vm.valueLoading = 90;
                  vm.$apollo
                    .mutate({
                      mutation: gql`
                        mutation compareFaces($id: String!) {
                          confidence: compare(id: $id)
                        }
                      `,
                      variables: {
                        id: accountId,
                        attempt: vm.counter
                      },
                      update: (cache, mutationResult) => {
                        vm.messageLoading = "Subiendo preguntas de seguridad.";
                        vm.valueLoading = 95;
                        if (mutationResult.data.confidence) {
                          vm.$apollo.mutate({
                            mutation: gql`
                              mutation setSecurityAnswers(
                                $accountId: Int!
                                $securityAnswers: [pSecurityAnswer!]!
                                $pSecurityQuestions: [Int!]!
                              ) {
                                setSecurityAnswers(
                                  accountId: $accountId
                                  securityAnswers: $securityAnswers
                                  pSecurityQuestions: $pSecurityQuestions
                                ) {
                                  answer
                                }
                              }
                            `,
                            variables: {
                              accountId: accountId,
                              securityAnswers: vm.securityAnswers,
                              pSecurityQuestions: vm.pSecurityQuestions
                            },
                            update: (cache, mutationResult) => {
                              vm.valueLoading = 100;
                              vm.$router.push("/messagePage/clientR");
                            }
                          });
                        } else {
                          vm.valueLoading = 0;
                          Swal.fire({
                            title: "Tus fotos no coinciden",
                            text:
                              "Recuerda quitarte accesorios de la cabeza como gafas o diademas y vuelve a intentarlo",
                            confirmButtonClass: "md-button md-success",
                            buttonsStyling: false
                          });
                        }
                      }
                    })
                    .catch(error => {
                      vm.valueLoading = 0;
                      Constants.catchError(
                        error,
                        vm.$apollo.provider.defaultClient,
                        vm,
                        true
                      );
                    });
                })
                .catch(error => {
                  vm.valueLoading = 0;
                  Constants.catchError(
                    error,
                    vm.$apollo.provider.defaultClient,
                    vm,
                    true
                  );
                });
            });
          });
        })
        .catch(error => {
          this.valueLoading = 0;
          Constants.catchError(
            error,
            this.$apollo.provider.defaultClient,
            this,
            true
          );
        });
    }
  }
};
</script>
